import React, { useState, useEffect } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
// import { RequiredServiceApi } from "../../../Redux/action/MasterAction";
// import RequiredServiceModal from "../../Modal/RequiredServiceModal";
// import EditRequiredService from "../../Modal/EditRequiredService";
import { BeatLoader } from "react-spinners";
// import Pagination from "../../Pagination";
import Skeleton from "react-loading-skeleton";
import { Table } from "antd";
// import Api from '../../../../Api';


import AddRcmCategory from "./AddRcmCategory";
import EditRcmCategory from "./EditRcmCategory";
import {
  getAllMasterRcmCategoryIdAndName,
  getMasterRcmCategory,
} from "../../../../../Redux/action/MasterAction";
import AccountPagination from "../../GroupMaster/AccountPagination";
import { adminMainUrl } from "../../../../../Config";


const RcmCategory = ({ accessedModules, accessedPermission }) => {
  const [currentData, setCurrentData] = useState([]);
  const {
   
    loadingMasterRcmCategory,
    MasterRcmCategory,
    MasterRcmCategoryError,
    MasterRcmCategoryCurrentPage,
    MasterRcmCategoryTotalPage,
    MasterRcmCategoryTotalData,

  } = useSelector((state) => state?.MasterReducer);

  // const [currentPage, setCurrentPage] = useState(MasterAccountParentGroupCurrentPage);
  // const [totalPages, setTotalPages] = useState(MasterAccountParentGroupTotalPage);
  const dataPerPage = 10;

  // console.log("MasterAccountParentGroup", MasterAccountParentGroup);
  const [parent_id, setParent_id] = useState(null);

  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => setAddShow(false);
  const handleAddShow = () => setAddShow(true);

  const [editshow, setEditShow] = useState(false);
  const handleEditClose = () => setEditShow(false);
  // const handleEditShow = () => setEditShow(true);
  const handleEditShow = (id) => {
    if (id) {
      setParent_id(id);
      setEditShow(true);
    } else {
      toast.error("Id not found. Please retry.");
    }
  };

  const [reload, setReload] = useState(false);
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [MasterName, setMasterName] = useState(null);
  const [MasterID, setMasterID] = useState(null);
  const navigate = useNavigate();
  // const { name } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;

  const queryParams = new URLSearchParams(location.search);


  useEffect(() => {
    // get all parent api call here
    // dispatch(getCommodity());
  }, [adminMainUrl, reload]);

  useEffect(() => {
    if (token && user_id) {
      dispatch(
        getMasterRcmCategory(
          token,
          user_id,
          queryParams.get("page") ?? 1,
          queryParams.get("search")
        )
      );
      dispatch(getAllMasterRcmCategoryIdAndName(token, user_id));
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id]);

  const refresh = () => {
    if (token && user_id) {
      dispatch(
        getMasterRcmCategory(
          token,
          user_id,
          queryParams.get("page") ?? 1,
          queryParams.get("search")
        )
      );
    }
  };

  const handleSuccess = () => {
    setReload((prev) => !prev);
  };


  useEffect(() => {
    setCurrentData(MasterRcmCategory);
  }, [MasterRcmCategory]);

  // Initialize Formik
  const statusChange = async (id) => {
    setSpinnerLoader(true);
    try {
      const response = await fetch(
        `${adminMainUrl}/api/account/rcm-category-master-status`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
          },
          body: JSON.stringify({ id: id.toString() }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        refresh();
        setSpinnerLoader(false);
        handleSuccess(); // Call the success handler
        toast.success(data?.msg);
      } else {
        setSpinnerLoader(false);
        toast.error(data?.msg);
      }
    } catch (error) {
      setSpinnerLoader(false);
      console.error("Network error:", error);
    }
  };

  const handleChange = (id) => {
    statusChange(id);
  };

  // const [grid, setGrid] = useState(true)
  const arr = new Array(5).fill(null);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const currentItems = MasterRcmCategory;

  const columns = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Rcm Category", dataIndex: "RcmCategory", key: "RcmCategory" },
    { title: "Status", dataIndex: "Status", key: "Status" },
    { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dataSource = currentData?.map((value, i) => ({
    key: i, // Add a unique key for each row
    SNo: i + 1, // Changed to camelCase
    RcmCategory: value?.name, // Ensure date formatting as neede
    Status: (
      <>
        <span
          id={`flexSwitchCheckChecked-${i}`}
          title="Click to change status"
          onClick={() => handleChange(value.id)}
          className={`cursor-pointer ${
            value.status === true
              ? "badge badge-pill badge-status bg-success"
              : "badge badge-pill badge-status bg-danger"
          }  `}
        >
          {value.status === true ? "Active" : "Inactive"}
        </span>
      </>
    ),
    action: (
      <div className="dropdown table-action">
        <Link to="#" className="action-icon" data-bs-toggle="dropdown">
          <i className="fa fa-ellipsis-v"></i>
        </Link>
        <div className="dropdown-menu dropdown-menu-right">
          <div
            className=" cursor-pointer"
            onClick={() => {
              handleEditShow(value?.id);
              setMasterID(value?.id);
              setMasterName(value?.name);
            }}
          >
            <i className="ti ti-edit text-blue"></i> Edit
          </div>
        </div>
      </div>
    ),
  }));

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                       Rcm Category
                      <span className="count-title">
                        {MasterRcmCategory?.length}
                      </span>
                    </h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-original-title="Collapse"
                        id="collapse-header"
                      >
                        <i className="ti ti-chevrons-up" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                <div className="d-flex align-items-center flex-wrap row-gap-2"></div>
                <div className="d-flex align-items-center flex-wrap row-gap-2">
                  <div
                    className="btn btn-primary cursor-pointer"
                    onClick={handleAddShow}
                  >
                    <i className="ti ti-square-rounded-plus me-2" />
                    Add Rcm Category
                  </div>
                </div>
              </div>

              {loadingMasterRcmCategory ? (
                arr.map((value, index) => {
                  return (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "400px", width: "100%" }}
                    >
                      <BeatLoader />
                    </div>
                  );
                })
              ) : spinnerLoader ? (
                <>
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "400px", width: "100%" }}
                  >
                    <BeatLoader />
                  </div>
                </>
              ) : (
                <>
                  <div className="table-responsive custom-table">
                    <Table
                      className="table datanew dataTable no-footer"
                      pagination={false}
                      dataSource={dataSource}
                      columns={columns}
                    />
                  </div>

                  <AccountPagination
                    currentPage={MasterRcmCategoryCurrentPage}
                    totalPages={MasterRcmCategoryTotalPage}
                    onPageChange={(page) => {
                      dispatch(
                        getMasterRcmCategory(token, user_id, page)
                      );
                    }}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <AddRcmCategory
        show={addShow}
        handleClose={handleAddClose}
        onSuccess={handleSuccess}
        refresh={refresh}
      />
      <EditRcmCategory
        parent_id={parent_id}
        show={editshow}
        handleClose={handleEditClose}
        onSuccess={handleSuccess}
        MasterID={MasterID}
        MasterName={MasterName}
        refresh={refresh}
      />
      {/* <EditEmployee id="offcanvas_edit" />
            <AddEmployee id="offcanvas_add" /> */}
      {/* <CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />

            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
    </>
  );
};

export default RcmCategory;
